import { __extends } from "tslib";
import { ParserBase, WaveAudio, WaveAudioData, WaveAudioParser } from '@awayjs/core';
var FlashWaveAudioParser = /** @class */ (function (_super) {
    __extends(FlashWaveAudioParser, _super);
    function FlashWaveAudioParser() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    FlashWaveAudioParser.prototype._pProceedParsing = function () {
        var data = this.data;
        var define = data.definition;
        var meta = {
            sampleRate: define.sampleRate,
            samplesCount: define.samplesCount,
            startOffset: define.packaged.seek,
        };
        //@ts-ignore
        this._pContent = new WaveAudio(new WaveAudioData(define.packaged.data.buffer, meta));
        this._pFinalizeAsset(this._pContent, this._iFileName);
        return ParserBase.PARSING_DONE;
    };
    return FlashWaveAudioParser;
}(WaveAudioParser));
export { FlashWaveAudioParser };
